// The tier is the badge's rarity, and its colour says so. TierName is the tier as
// the art names it ("Ruby", "Gold", "Paper") on a pill in the tier's colour, with
// a black outline so Paper reads on white and Rock reads on the dark stage.
// TierLineView is the whole line: "First on the site. [Ruby] 2 of 41 members have it."
import React from "react";
import { tierStyle } from "./art/badgeLib";
import { tierLabel, type TierLine } from "./collection/badgeFormat";
import "./tierName.css";

export const TierName: React.FC<{ tier: string; className?: string }> = ({ tier, className }) => {
  const s = tierStyle(String(tier).toUpperCase());
  const vars = { "--tn-fill": s.fill, "--tn-ink": s.ink, "--tn-glow": s.glow ?? "transparent" } as React.CSSProperties;
  return (
    <span className={`bdg-tiername${className ? ` ${className}` : ""}`} data-tier={String(tier).toUpperCase()} style={vars}>
      {tierLabel(tier)}
    </span>
  );
};

/**
 * The tier line. The period after the tier is only there for screen readers and
 * for the line's text; on screen the pill ends it. `stacked` puts the fact under
 * the pill (the shelf tiles).
 */
export const TierLineView: React.FC<{
  line: TierLine;
  className?: string;
  stacked?: boolean;
}> = ({ line, className, stacked = false }) => (
  <span className={`bdg-tierline${stacked ? " bdg-tierline--stacked" : ""}${className ? ` ${className}` : ""}`}>
    {line.lead && (
      <>
        <b className="bdg-tierline__lead">{line.lead}</b>{" "}
      </>
    )}
    <TierName tier={line.tier} />
    <span className="bdg-tierline__sr">.</span>
    {line.fact && (
      <>
        {" "}
        <span className="bdg-tierline__fact">{line.fact}</span>
      </>
    )}
  </span>
);

export default TierName;
